<app-sliding-window [toggleWindow]="showCommentWindow$ | async" [contentPaddingRem]="0">
  <div header>
    <app-sliding-window-header
      [slidingWindowOptions]="commentWindowOptions$ | async"
      (closeButtonClicked)="toggleCommentWindow()" />
    <app-tab-bar
      class="d-block mt-3 mx-4"
      [tabs]="tabs$ | async"
      [skipFragmentAppending]="true"
      (selectedTab)="setActiveTab($event)" />
    <hr class="mb-0" />
  </div>
  <div content>
    <app-tab-content [showContent]="true" [tab]="(activeTab$ | async) ?? undefined" />
  </div>
  <app-sliding-window-footer
    footer
    [slidingWindowOptions]="commentWindowOptions$ | async"
    (primaryButtonClicked)="primaryButtonClicked()"
    (secondaryButtonClicked)="toggleCommentWindow()" />
</app-sliding-window>

<button
  type="button"
  [style.margin-bottom.rem]="buttonMarginBottomRem"
  class="comment-button"
  [ngClass]="{
    'unread-comments-button': (hasUnreadComments$ | async),
    'no-unread-comments-button': !(hasUnreadComments$ | async)
  }"
  (click)="toggleCommentWindow()">
  <div class="d-flex flex-column align-items-center">
    <img [src]="commentButtonIconSrc$ | async" class="bubble" alt="Comments" i18n-alt />
    <img *ngIf="hasUnreadComments$ | async" class="indicator" src="assets/icons/white/Indicator.svg" />
  </div>
</button>
